import { useState } from 'react';
import {findMatchingChildSku} from '../components/helper'
import StepNavigation from '../components/_StepNavigation';
import StepAddress from '../components/StepAddress';
import StepBundle from '../components/StepBundle';
import StepCustomize from '../components/StepCustomize';
import StepPreview from '../components/StepPreview';
import StepIntro from '../components/StepIntro';
import {submitOrder} from '../../services/magento/api'
import '../styles/ProductPage.css';


const ProductPage = () => {
  const [currentStep, setCurrentStep] = useState(0);
  const [formData, setFormData] = useState({});
  const [stepValidator, setStepValidator] = useState(() => () => true);
  const [maxStepReached, setMaxStepReached] = useState(0);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submissionResult, setSubmissionResult] = useState(null);
  const [submissionMessage, setSubmissionMessage] = useState('');

  const updateData = (newData) => {
    setFormData((prev) => ({ ...prev, ...newData }));
  };

  const nextStep = () => {
    if (stepValidator()) {
      setCurrentStep((prev) => {
        const next = Math.min(prev + 1, 6);
        setMaxStepReached((prevMax) => Math.max(prevMax, next));
        return next;
      });
    }
  };

  const prevStep = () => {
    setCurrentStep((prev) => Math.max(prev - 1, 0));
  };

  const renderStep = () => {
    switch (currentStep) {
      case 0: return <StepIntro />;
      case 1: return <StepAddress data={formData} updateData={updateData} setStepValidator={setStepValidator}/>;
      case 2: return <StepBundle data={formData} updateData={updateData} setStepValidator={setStepValidator}/>;
      case 3: return <StepCustomize data={formData} updateData={updateData} setStepValidator={setStepValidator} stepKey="customizeOne" stepIndex={0} page='First Preference'/>;
      case 4: return <StepCustomize data={formData} updateData={updateData} setStepValidator={setStepValidator} stepKey="customizeTwo" stepIndex={1} page='Second Preference' />;
      case 5: return <StepCustomize data={formData} updateData={updateData} setStepValidator={setStepValidator} stepKey="customizeThree" stepIndex={1} page='Third Preference'/>;
      case 6: return <StepPreview data={formData} updateData={updateData}/>;
      default: return null;
    }
  };

  const handleSubmit = async () => {
  setIsSubmitting(true);
  setSubmissionResult(null);
  setSubmissionMessage('Submitting your order...');

  const {
    bundle,
    customizeOne = [],
    customizeTwo = [],
    customizeThree = [],
    company,
    phone,
    zipcode,
    city,
    firstName,
    lastName,
    email,
    state,
    region_id,
    address1,
    address2,
    country_id
  } = formData;

  const products = [
    { product: {sku: bundle.sku}, choiceValue: 'gift' },
    ...customizeOne.map(item => {
      const selectedSize = item.selectedSize;
      const selectedColor = item.selectedColor;
      const matchedSku = findMatchingChildSku(item, selectedSize, selectedColor);

      return {
        product: {
          sku: matchedSku,
        },
        choiceValue: 'first'
      };
    }),
    ...customizeTwo.map(item => {
      const selectedSize = item.selectedSize;
      const selectedColor = item.selectedColor;
      const matchedSku = findMatchingChildSku(item, selectedSize, selectedColor);

      return {
        product: {
          sku: matchedSku,
        },
        choiceValue: 'second'
      };
    }),
    ...customizeThree.map(item => {
      const selectedSize = item.selectedSize;
      const selectedColor = item.selectedColor;
      const matchedSku = findMatchingChildSku(item, selectedSize, selectedColor);

      return {
        product: {
          sku: matchedSku,
        },
        choiceValue: 'third'
      };
    }),
  ];

  const payload = {
    products,
    company: company || 'Nexeo',
    telephone: phone,
    postcode: zipcode,
    city,
    firstname: firstName,
    lastname: lastName,
    email,
    region: state,
    region_id: region_id || null,
    region_code: state,
    street: [address1, address2].filter(Boolean),
    country_id,
    shipping_method_code: 'freeshipping',
    shipping_carrier_code: 'freeshipping'
  };

  try {
    const response = await submitOrder(payload);
    if (!response.error) {
      setSubmissionResult('success');
      setSubmissionMessage('Order submitted successfully!');
    } else {
      setSubmissionResult('error');
      setSubmissionMessage(`Order failed: ${response.error}`);
    }
  } catch (error) {
    setSubmissionResult('error');
    setSubmissionMessage(`Order failed: ${error.message}`);
  }
};



  return (
    <div className="product-page">
    {isSubmitting && (
      <div className="loading-overlay">
        <div className="loading-modal">
          {submissionResult === null && (
            <>
              <div className="spinner" />
              <p>{submissionMessage}</p>
            </>
          )}

          {submissionResult === 'success' && (
            <>
              <p>{submissionMessage}</p>
              <button className="modal-button" onClick={() => window.location.href = '/nexeo'}>
                Thank you
              </button>
            </>
          )}

          {submissionResult === 'error' && (
            <>
              <p>{submissionMessage}</p>
              <button className="modal-button" onClick={() => setIsSubmitting(false)}>
                OK
              </button>
            </>
          )}
        </div>
      </div>
    )}
      <h1>{''}</h1>
      <StepNavigation currentStep={currentStep} setStep={setCurrentStep} maxStepReached={maxStepReached} />
      
      <div className="step-content">{renderStep()}</div>
      
      <div className="navigation-buttons">
        {currentStep > 0 && <button onClick={prevStep}>Back</button>}
        {currentStep < 6 && <button onClick={nextStep}>Next</button>}
        {currentStep === 6 && <button onClick={handleSubmit}>Submit</button>}
      </div>
    </div>
  );
};

export default ProductPage;
